export function isOptimisticSessionId(
  sessionId: string | null | undefined
): boolean {
  return Boolean(
    sessionId && (sessionId === "temp-id" || sessionId.startsWith("temp-"))
  );
}

/** The timer's narrower check: only the single optimistic "temp-id" is unconfirmed. */
export function isConfirmedServerSessionId(
  sessionId: string | null | undefined,
): boolean {
  return Boolean(sessionId && sessionId !== "temp-id");
}

export function isConfirmedSessionId(
  sessionId: string | null | undefined
): boolean {
  return Boolean(sessionId) && !isOptimisticSessionId(sessionId);
}
